import { Stack } from "@/core/components/ui/stack";
import { toast } from "@/core/components/ui/toast";
import { BusinessSettingsSidebarHeader } from "@/business-settings/common/business-settings-sidebar-header";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";
import { getErrorMessage } from "@/core/api/errors";
import { getUserFullName } from "@/core/utils/name";
import { FilterableSpiffList } from "@/spiffs/common/filterable-spiff-list";
import { useSpiffSidebar } from "@/spiffs/context/spiff-sidebar-context";
import { useDismissSpiff, useGetUserPendingSpiffs } from "@/spiffs/query";
import { useGetBusinessUser } from "@/user/query";

interface PendingSpiffsSidebarProps {
  userId: string;
  businessId?: string | null;
}

const SpiffPaymentsDueSidebar = ({
  userId,
  businessId,
}: PendingSpiffsSidebarProps) => {
  const { resetSidebar } = useSpiffSidebar();
  const { data: user } = useGetBusinessUser(businessId, userId);
  const { data: pendingSpiffs = [] } = useGetUserPendingSpiffs(userId);
  const { mutate: dismissSpiff } = useDismissSpiff(businessId);

  const name = user ? getUserFullName(user) : "Unknown User";

  const handleDismissSpiff = (spiffId: string) => {
    dismissSpiff(
      { spiffIds: [spiffId] },
      {
        onSuccess: () => {
          toast.success("Spiff payout dismissed");
        },
        onError: (error) => {
          toast.error("Failed to dismiss spiff payout", {
            description: getErrorMessage(error),
          });
        },
      },
    );
  };

  return (
    <BusinessSettingsSidebarWrapper>
      <BusinessSettingsSidebarHeader
        headerText="Pending spiffs for"
        name={name}
        onClose={resetSidebar}
      />
      <Stack
        gap="none"
        fullWidth
        className="h-full min-h-0 flex-1 pl-6 pr-2 pt-4"
      >
        <FilterableSpiffList
          spiffs={pendingSpiffs}
          onDismissSpiff={handleDismissSpiff}
          emptyMessage="No active spiff payouts"
        />
      </Stack>
    </BusinessSettingsSidebarWrapper>
  );
};

export default SpiffPaymentsDueSidebar;
